import { render, staticRenderFns } from "./PortfolioDetails.vue?vue&type=template&id=229e9cf5&scoped=true"
import script from "./PortfolioDetails.vue?vue&type=script&lang=js"
export * from "./PortfolioDetails.vue?vue&type=script&lang=js"
import style0 from "./PortfolioDetails.vue?vue&type=style&index=0&id=229e9cf5&prod&scoped=true&lang=css"
import style1 from "./PortfolioDetails.vue?vue&type=style&index=1&id=229e9cf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e9cf5",
  null
  
)

export default component.exports